<template>
	<div class="bg-transparent d-flex m-t-16 m-d-16">
		<div class="f-regular font-16 f-c-blue status-login">
			<span class="font-weight-bold">
				Langkah {{ step }}/{{ total }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOStep",
	props: {
		step: Number,
		total: Number,
	}
}
</script>